export type PoFormViewProps = {
    data: any
}

export enum ProtocolDictionaryTypes {
    Authors,
    Institutions,
    InstitutionsPerAuthor,
    AuthorInstitution
}

export enum InstitutionDictionaryType {
    PerAuthor = 1,
    Full = 2        // All but institutions that the author is already assigned to
}